import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "substitute-application" }
const _hoisted_2 = { class: "allowance-detail" }
const _hoisted_3 = { class: "font-size-24 font-bold" }
const _hoisted_4 = { class: "mt-8" }
const _hoisted_5 = { class: "mb-8" }
const _hoisted_6 = { class: "font-bold text-lg mb-1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_8 = { class: "text-xl" }
const _hoisted_9 = { class: "mb-8" }
const _hoisted_10 = { class: "font-bold text-lg mb-1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "box-time flex font-size-32" }, [
  /*#__PURE__*/_createVNode("p", { class: "mr-4" }, "1.0日"),
  /*#__PURE__*/_createVNode("p", { class: "mr-4" }, "2:00")
], -1)
const _hoisted_14 = { class: "mb-8" }
const _hoisted_15 = { class: "font-bold text-lg mb-1" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = { class: "w-2/5" }
const _hoisted_19 = {
  key: 0,
  class: "mt-4 pb-4"
}
const _hoisted_20 = { class: "font-bold text-lg pb-1 border-b-1 border-blue-600 mb-3" }
const _hoisted_21 = { class: "substitute-required mb-2 mt-1.5 font-size-12" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-xl" }, null, -1)
const _hoisted_23 = { class: "flex flex-wrap items-baseline" }
const _hoisted_24 = { class: "w-38 mr-5" }
const _hoisted_25 = { class: "w-38 mr-5" }
const _hoisted_26 = { class: "font-size-14 mr-5" }
const _hoisted_27 = { class: "w-38 mr-5" }
const _hoisted_28 = { class: "font-size-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Button = _resolveComponent("Button")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_RadioInput = _resolveComponent("RadioInput")
  const _component_Select = _resolveComponent("Select")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_ReasonCreateApplication = _resolveComponent("ReasonCreateApplication")
  const _component_ReasonUpdateStatusApplication = _resolveComponent("ReasonUpdateStatusApplication")
  const _component_ApplicationApproveFlowDetail = _resolveComponent("ApplicationApproveFlowDetail")
  const _component_PopupDetailSubstituteApplication = _resolveComponent("PopupDetailSubstituteApplication")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_BackPreviousPage, { onClick: _ctx.returnScreen }, null, 8, ["onClick"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('personalSettingApply.substituteLeaveApplication')), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('stampRegister.targetDate')), 1),
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode("div", null, _toDisplayString(_ctx.formatTimeDate(_ctx.targetDate, _ctx.DEFINE_DAY)), 1)
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('substituteApplication.numberOfDays')), 1),
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_Button, {
                disabled: !!_ctx.applicationFormId,
                class: "h-32",
                onClick: _ctx.openPopupSubstitute
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('substituteApplication.checkExpirationDate')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.t('substituteApplication.acquisitionUnit')), 1),
            _hoisted_16,
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_RadioGroup, {
                  "options-radio": _ctx.acquisitionList,
                  modelValue: _ctx.apiPostData.substitute_time_type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiPostData.substitute_time_type = $event)),
                  disabled: !!_ctx.applicationFormId
                }, null, 8, ["options-radio", "modelValue", "disabled"]),
                (
                  _ctx.apiPostData.substitute_time_type ===
                  _ctx.USING_TYPE_SUBSTITUTE_APPLICATION.HALF_DAY
                )
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: ["drop-half-day bg-blue-pale", !!_ctx.applicationFormId ? 'pointer-events-none' : null]
                    }, [
                      _createVNode(_component_RadioInput, {
                        class: "flex flex-column px-5 pt-5",
                        "options-radio": _ctx.halfDayList,
                        modelValue: _ctx.apiPostData.half_day_type,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.apiPostData.half_day_type = $event)),
                        disabled: !!_ctx.applicationFormId
                      }, null, 8, ["options-radio", "modelValue", "disabled"])
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (
            _ctx.apiPostData.substitute_time_type ===
            _ctx.USING_TYPE_SUBSTITUTE_APPLICATION.TIME_OFF
          )
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_ctx.t('shiftRegistration.targetTime')) + " ", 1),
                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.t('required')), 1)
                ]),
                _hoisted_22,
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _createVNode(_component_Select, {
                      placeholder: _ctx.t('choice'),
                      "options-select": _ctx.optionsChoseTime,
                      "item-text": "text",
                      modelValue: _ctx.apiPostData.setting_day_type,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.apiPostData.setting_day_type = $event)),
                      errors: _ctx.errors.setting_day_type,
                      "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.setting_day_type = $event)),
                      "error-server": _ctx.errorsServer.setting_day_type,
                      validated: _ctx.validated,
                      required: "",
                      disabled: !!_ctx.applicationFormId
                    }, null, 8, ["placeholder", "options-select", "modelValue", "errors", "error-server", "validated", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _createVNode(_component_InputTime, {
                      modelValue: _ctx.apiPostData.start_time,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.apiPostData.start_time = $event)),
                      errors: _ctx.errors.start_time,
                      "onUpdate:errors": _cache[6] || (_cache[6] = ($event: any) => (_ctx.errors.start_time = $event)),
                      "error-server": _ctx.errorsServer.start_time,
                      validated: _ctx.validated,
                      disabled: !!_ctx.applicationFormId,
                      required: ""
                    }, null, 8, ["modelValue", "errors", "error-server", "validated", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.t('substituteApplication.from')), 1),
                  _createVNode("div", _hoisted_27, [
                    _createVNode(_component_InputTime, {
                      modelValue: _ctx.apiPostData.time_off,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.apiPostData.time_off = $event)),
                      errors: _ctx.errors.time_off,
                      "onUpdate:errors": _cache[8] || (_cache[8] = ($event: any) => (_ctx.errors.time_off = $event)),
                      "error-server": _ctx.errorsServer.time_off,
                      validated: _ctx.validated,
                      disabled: !!_ctx.applicationFormId,
                      required: ""
                    }, null, 8, ["modelValue", "errors", "error-server", "validated", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_28, _toDisplayString(_ctx.t('substituteApplication.makeVacation')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_ReasonCreateApplication, {
      "is-valid": !_ctx.isDisableSubmit,
      modelValue: _ctx.apiPostData.application_reason,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.apiPostData.application_reason = $event)),
      validated: _ctx.validated,
      errors: _ctx.errors.application_reason,
      "onUpdate:errors": _cache[10] || (_cache[10] = ($event: any) => (_ctx.errors.application_reason = $event)),
      "error-server": _ctx.errorsServer.application_reason,
      onHandleCreateApplication: _ctx.createSubstituteLeaveApplication,
      onHandleCancel: _ctx.returnScreen
    }, null, 8, ["is-valid", "modelValue", "validated", "errors", "error-server", "onHandleCreateApplication", "onHandleCancel"]),
    (!!_ctx.applicationFormId)
      ? (_openBlock(), _createBlock(_component_ReasonUpdateStatusApplication, {
          key: 0,
          status: _ctx.substituteLeaveApplicationDetail?.application_status
        }, null, 8, ["status"]))
      : _createCommentVNode("", true),
    (!!_ctx.applicationFormId)
      ? (_openBlock(), _createBlock(_component_ApplicationApproveFlowDetail, {
          key: 1,
          status: _ctx.statusApplicationFlow,
          createdAt: _ctx.createdAt
        }, null, 8, ["status", "createdAt"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PopupDetailSubstituteApplication, {
      modelValue: _ctx.isShowPopupSubstitute,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isShowPopupSubstitute = $event)),
      onOnClose: _ctx.closePopupSubstitute
    }, null, 8, ["modelValue", "onOnClose"])
  ], 64))
}